// 签到领现金相关路由
export default {
  routes: [
    // 签到领现金首页
    {
      path: '/util',
      name: 'util',
      meta: {
        auth: true
      },
      component: () => import(/* webpackChunkName: "util" */ '../views/util/index.vue')
    },
    // 小程序私域聚合页
    {
      path: '/util/personalShareToWX',
      name: 'personalShareToWX',
      component: () =>
        import(/* webpackChunkName: "personalShareToWX" */ '../views/util/personalShareToWX.vue')
    }
  ]
}
